import React from "react";
import moment from "moment-timezone";
import fieldPropTypes from "./field-prop-types";
import { idCreator } from "../utils/id-creator";

const FormTextLabel = ({ field, appData, components: { Text, Label } }) => {
  if (
    !field.text &&
    (field.params || []).includes("TDFieldOptionIncludeIfNotEmpty")
  ) {
    return null;
  }

  let label = field.text || appData.values[field.name];

  const { labelId } = idCreator(field?.name);

  const convertFullDate = (field.params || []).includes(
    "TDFieldOptionConvertFullDate"
  );
  const knownFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(label);

  if (convertFullDate && knownFormat) {
    const asMoment = moment.tz(label, appData.values.time_zone);
    label = `${asMoment.format("dddd, MMMM D, YYYY")} at ${asMoment.format(
      "h:mm A zz"
    )}`;
  }

  return (
    <div
      className={`text-label-wrapper-web-sdk ${field.name}`}
      data-testid={`text-label-wrapper-${field.name}`}
    >
      {field.title ? (
        <Label labelId={labelId} text={field.title} params={field.params} />
      ) : null}
      {label ? <Text label={label} name={field.name} /> : null}
    </div>
  );
};

FormTextLabel.propTypes = fieldPropTypes;

export default FormTextLabel;
